module.exports = __webpack_public_path__ + "img/H2.984d171f.png";